import {
	apiGet
} from './api';

// 公告分页列表
export const queryNoticePage = (params) => {
	return apiGet('/system/notice/page', params);
};

// 公告详情
export const getNoticeDetail = (id) => {
	return apiGet('/system/notice/get', {
		id
	});
};
